/* eslint-disable */
import styled from 'styled-components';
import { SYS_BORDER_RADIUS_MAX } from '@oneaudi/unified-web-common';
import { Headline } from '@oneaudi/unified-web-components';
import AudiLogo from './AudiLogo';

type MapMarkerContainerProps = {
  isMobileScreen: boolean;
};

export const MapMarkerContainer = styled.div.attrs((props: { 'data-testid': string }) => ({
  className: 'map-marker__container',
  'data-testid': props['data-testid'] ? props['data-testid'] : 'map-marker-container',
  // 'data-testid': 'map-marker-container',
}))<MapMarkerContainerProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  cursor: pointer;
  width: ${({ isMobileScreen }) => `${isMobileScreen ? 44 : 48}px`};
  height: ${({ isMobileScreen }) => `${isMobileScreen ? 44 : 48}px`};
`;

const getMapMarkerContentBackgroundColor = (isSelected?: boolean, isHovered?: boolean): string => {
  if (isSelected) {
    return process.env.IS_LEGACY ? '#f50537' : '#fff';
  }

  if (isHovered) {
    return '#4c4c4c';
  }

  return '#000';
};

type MapMarkerContentProps = {
  isSelected?: boolean;
  isHovered?: boolean;
};

const isLegacy = process.env.IS_LEGACY;
export const MapMarkerContent = styled.div.attrs(({ isHovered }: MapMarkerContentProps) => ({
  className: `map-marker__icon-container${isHovered ? ' map-marker-icon-container_hovered' : ''}`,
  // 'data-test-id': 'map-marker-icon-container',
  'data-testid': 'map-marker-icon-container',
}))<MapMarkerContentProps>`
  width: fit-content;
  height: ${isLegacy ? '80%' : 'auto'};
  padding: ${isLegacy ? '0' : '8px 4px;'};

  background: ${({ isSelected, isHovered }) =>
    getMapMarkerContentBackgroundColor(isSelected, isHovered)};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${!isLegacy && SYS_BORDER_RADIUS_MAX};
  border: ${!isLegacy && `1px solid #fff`};
  color: #fff;
  svg {
    color: ${({ isSelected }) => isSelected && !isLegacy && '#000'};
    g {
      path {
        fill: ${({ isSelected }) => isSelected && !isLegacy && '#000'};
      }
    }
  }

  ::after {
    content: '';
    width: 12px;
    height: 12px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    bottom: ${isLegacy ? '-6px' : '-7px'};
    background: inherit;
    z-index: ${isLegacy ? '-1' : '1'};
    border: ${!isLegacy && `1px solid #fff`};
    border-top: none;
    border-left: none;
  }
`;

export const MapMarkerNumOfDealers = styled(Headline).attrs({
  'data-test-id': 'cluster-marker__num-dealers',
})``;

export const MapMarkerDealerIconContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MapMarkerDefaultIcon = styled(AudiLogo)`
  display: block;
  width: fit-content;
  padding: 0 4px;
`;
